// stagger reveal grouping of elements 
ScrollTrigger.batch(".animate-fadeIn", {
    interval: 0.1,
    onEnter: batch => gsap.to(batch, {
        autoAlpha: 1,
        duration: 0.3,
        stagger: {
            each: 0.3
        }
    }),
});

// reveal element by sliding up
ScrollTrigger.batch(".animate-slideUp", {
    interval: 0.1,
    onEnter: batch => gsap.to(batch, {
        autoAlpha: 1,
        y: 0,
        duration: 0.3,
        stagger: {
            each: 0.3
        }
    }),
});

// reveal element by sliding in from left to right
ScrollTrigger.batch(".animate-slideRight", {
    interval: 0.3,
    onEnter: batch => gsap.to(batch, {
        autoAlpha: 1,
        x: 0,
    }),
});

// reveal element by sliding in from right to left
ScrollTrigger.batch(".animate-slideLeft", {
    interval: 0.3,
    onEnter: batch => gsap.to(batch, {
        autoAlpha: 1,
        x: 0,
    }),
});
